module.exports = __webpack_public_path__ + "mainassets/img/faqBackground.523d13ed.svg";